<template>
  <ScaleBox v-if="isMobile">
    <router-view :platInfo="platInfo"></router-view>
  </ScaleBox>
  <router-view v-else :platInfo="platInfo"></router-view>
  <!-- <iframe id="topFrame" src="https://nfstzx.com/iframeMes" style="display:none;"></iframe> -->
</template>

<script>

import { getCurrentInstance,ref,onBeforeMount,computed,onUnmounted} from "vue";
import { useStore } from "vuex";

import ScaleBox from "./components/ScaleBox.vue"
export default {
  name: 'App',
  components: {
    ScaleBox
  },
  setup(){
    const { proxy } = getCurrentInstance();
    const store = useStore();
    // 动态更改favicon
		const	changeFavicon=(src)=>{
      var link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      link.href = src;
    }
    //获取门户信息
    const getWebInfo=()=>{
      proxy.$request({
        url:"B2B_N_MANAGE_FINDDEFAULT",
        method: "post",
      }).then((res)=>{
        if(res.data.code=="000"){
          let result=res.data.result;
          console.log(result,'信息')
          document.title = result.browserName;
          changeFavicon(proxy.commenUrl+result.browserIcon);
          store.commit("setb2bWebInfo",result);
        }
      }).catch((err)=>{
        console.log(err)
      })
    }
    getWebInfo();
    const platInfo = ref({})
    //获取产业门户信息
    const getPortalInfo = () => {
      proxy
        .$request({
          url: "PROTAL_N_INDUSTRYMANGE_FINDDEFAULTBYTYPE",
          data: {
            portalType: "nfstzx"
          },
          method: "post",
        })
        .then((res) => {
          if (res.data.code == "000") {
            let result = res.data.result;
            changeFavicon(proxy.commenUrl + result.browserIcon);
            document.title = result.browserName;
            platInfo.value.tradeImg = res.data.result.tradeImg
            platInfo.value.gzh = res.data.result.gzh
            platInfo.value.tel = res.data.result.tel
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };
    getPortalInfo()
    // onBeforeMount(()=>{
    //   // 1. 获取 iframe 元素
    //   const iframe = document.getElementById("topFrame");

    //   // 2. iframe 加载完成后，发送数据请求
    //   iframe.onload = () => {
    //     iframe.contentWindow.postMessage("requestData", "https://nfstzx.com");
    //   };
    //   // 3. 监听顶级域名返回的数据
    //   window.addEventListener("message", (event) => {
    //     if (event.origin === "https://nfstzx.com") {
    //       if(event.status)return
    //       const data = event.data; // 解析收到的数据
    //       proxy.setCookie("userInfoB2B", data.userInfoB2B||'');
    //       proxy.setCookie("membIdB2B", data.membIdB2B||'');
    //     }
    //   });
    // })
    //获取屏幕尺寸
    // 防抖函数
    const debounceTimeout = ref(null)
    const debounceResize = () => {
        if (debounceTimeout.value) clearTimeout(debounceTimeout.value);
        debounceTimeout.value = setTimeout(() => {
            calculateHeight();
        }, 200);
    };

    const windowWidth = ref(window.innerWidth)
    const calculateHeight = () => {
        windowWidth.value = window.innerWidth;
    };
    const isMobile = computed(() => {
      console.log(windowWidth.value,'宽度')
      return windowWidth.value < 768;
    });

    const COOKIE_NAME = 'userInfoB2B';
    let lastToken = null;
    let intervalId = null;

    // 获取当前 token 值
    function getToken() {
      const match = document.cookie.match(new RegExp(`(^| )${COOKIE_NAME}=([^;]*)`));
      return match ? decodeURIComponent(match[2]) : null;
    }

    // Token 变化时的回调函数
    function onTokenChange(newToken, oldToken,type) {
      //type 1 监听 2 轮询
      
      // ✅ 在这里编写你的业务逻辑
      // 示例：
      if (newToken) {
        // Token 新增或更新
        if(type==2){
          proxy.setCookie("userInfoB2B", proxy.getSharedCookie("userInfoB2B"));
          proxy.setCookie("membIdB2B", proxy.getSharedCookie("membIdB2B"));
          // 判断是否是safari浏览器
          if(proxy.tool.isSafari()){
            //刷新页面
            window.location.reload()
          }
        }else if(type==1){
          proxy.setSharedCookie("userInfoB2B", proxy.getCookie("userInfoB2B"))
          proxy.setSharedCookie("membIdB2B",  proxy.getCookie("membIdB2B"))
        }else{
          proxy.setCookie("userInfoB2B", proxy.getSharedCookie("userInfoB2B"));
          proxy.setCookie("membIdB2B", proxy.getSharedCookie("membIdB2B"));
        }
        
      } else {
        // Token 被删除
        if(type==2){
          proxy.setCookie("userInfoB2B", '')
          proxy.setCookie("membIdB2B", '')
        }else if(type==1){
          proxy.setSharedCookie("userInfoB2B", '')
          proxy.setSharedCookie("membIdB2B", '')
        }else{
          proxy.setCookie("userInfoB2B", '')
          proxy.setCookie("membIdB2B", '')
        }
        
      }
    }

    onBeforeMount(() => {
      lastToken = getToken();
      if(lastToken){
        onTokenChange(getToken(), '',3)
      }
      // onTokenChange(getToken(), '',3)
      // 1️⃣ 监听 localStorage 事件（实时性高）
      window.addEventListener('storage', (e) => {
        if (e.key === `cookie_sync_${COOKIE_NAME}`) {
          const data = JSON.parse(e.newValue);
          if (data.value !== lastToken&&!data.value) {
            onTokenChange(data.value, lastToken,1);
            lastToken = data.value;
          }
        }
      });

      // 2️⃣ 轮询作为保底方案（3秒检查一次）
      intervalId = setInterval(() => {
        const current = getToken();
        if (current !== lastToken) {
          onTokenChange(current, lastToken,2);
          lastToken = current;
        }
      }, 1000);
      
      calculateHeight();
      window.addEventListener('resize', debounceResize);
    });

    onUnmounted(() => {
      clearInterval(intervalId);
      window.removeEventListener('resize', debounceResize);
    });
    return{
      platInfo,
      isMobile
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* min-width: 1400px; */
  font-size: 14px;
  width: 100%;
  height: 100%;


}
body {
  margin: 0 !important;
  padding: 0;
  background-color: #f7f8fa;
}
body,html{
  width: 100%;
  height: 100%;
}
</style>
